import MuiList from '@mui/material/List';
import { FC, PropsWithChildren } from 'react';

const List: FC<PropsWithChildren> = ({ children }) => (
  <MuiList
    disablePadding
    sx={{
      backgroundColor: 'white',
    }}
  >
    {children}
  </MuiList>
);

export default List;
